

























































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import ReportTemplateDialogComponent from '@/components/ReportTemplateDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { Request } from '@/domain/Request'
import { ReportType } from '@/domain/ReportType'
import { WindowPosition } from '@/domain/WindowPosition'
import InspectsService, { SerchConditon } from '@/service/InspectsService'
import ReportTemplateService from '@/service/ReportTemplateService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    ReportTemplateDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberInspectionList extends Mixins(GlobalMixin) {
  inspectionsService = InspectsService.instance
  reportTemplateService = ReportTemplateService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "検査開始日", value: "inspectionOn", width: "110px" },
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "120px" },
          { text: "検体識別記号", value: "specimenId", width: "130px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "検査分類", value: "sumInfo.classificationNames", width: "130px" },
          { text: "重量", value: "weight", align: "end", width: "100px" },
          { text: "着日", value: "receiptOn", width: "100px" },
          { text: "検査員", value: "inspectionUser.userName", width: "100px" },
          { text: "納品予定日", value: "deliveryOn", width: "110px" },
          { text: "報告完了", value: "reportCompleted", align: "center", width: "100px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "120px" },
  ]
  list: Request[] = []
  selectItems: Request[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  itemKey = ""

  requestNo = ""
  reportTypeSelectDialog = false

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    return this.selectItems.length === 1
  }

  /**
   * 報告書作成ボタンの無効
   */
  get disableReport() {
    return this.selectItems.filter(x => x.reportCompleted).length !== 0
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.inspection.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.inspection.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.inspection.list.conditions", JSON.stringify(this.conditions))
    this.inspectionsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.inspection.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Request): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Request) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.requestNo) {
      this.onDownloadReport(event.requestNo)
    }
    this.rowItemKey = event.requestNo
    this.rowItemClickTime = now
  }

  /**
   * 依頼書の表示
   */
  onViewRequest(requestNo: string) {
    this.showLoading()
    this.requestsService.download(requestNo)
        .then(file => {
          if (file.content === "") {
            this.alert("依頼書が登録されていません", ALERT_TYPE.ERROR)
          } else {
            this.openPdfViewDialog("依頼書", file.content)
          }
          this.hideLoading()
        })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("ダウンロードエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 報告書テンプレートのダウンロード
   */
  onDownloadReport(requestNo: string) {
    this.requestNo = requestNo
    this.reportTypeSelectDialog = true
  }

  /**
   * 報告書テンプレートのダウンロード
   */
  // eslint-disable-next-line
  onReportTypeSelected(event: ReportType) {
    this.showLoading()
    this.reportTemplateService.download(event.code, this.requestNo)
      .then(x => {
        this.download(x)
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("ダウンロードエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 報告書作成
   */
  onReport() {
    const query = this.selectItems.map(x => x.requestNo)
        .join(",")
    this.$router.push("/member/report/new?refs=" + query)
  }
  
  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.inspection.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.inspection.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.inspection.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
